export const zhCnLocale = {
  model: {
    designer: '设计师'
  },
  designer: {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    avatar: '头像',
  }
}

export const enLocale = {
  model: {
    designer: 'Designer'
  },
  designer: {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    name: 'Name',
    avatar: 'Avatar',
  }
}

